import { createNotification } from "../../_helpers";
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from "../_redux-constants";

function addNotification(options = {}) {
  return {
    payload: createNotification(options),
    type: ADD_NOTIFICATION,
  };
}

function removeNotification(id) {
  return {
    payload: id,
    type: REMOVE_NOTIFICATION,
  };
}

export const notificationActions = {
  addNotification,
  removeNotification,
};
